import { DataTable } from 'react-native-paper';

export default DataTable;
